import React from "react";

import "./FooterList.scss";

export type FooterListProps = {
  cx?: string;
  title: string;
  list: { link: string; text: string }[];
};

export const FooterList: React.FC<FooterListProps> = ({
  cx = "",
  list,
  title,
}) => {
  return (
    <div className={`FooterList ${cx}`}>
      <span>{title}</span>
      <ul>
        {list.map(({ link, text }, idx) => (
          <li key={`${text}-${idx}`}>
            <a href={link}>{text}</a>
          </li>
        ))}
      </ul>
    </div>
  );
};
